import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Clock, ShieldCheck } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-32 pb-20 md:pt-40 md:pb-32 px-6 overflow-hidden bg-white" data-id="element-63">
      <div className="max-w-7xl mx-auto" data-id="element-64">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-65">
          {/* Left Column - Text Content */}
          <div className="relative z-10" data-id="element-66">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            ease: 'easeOut'
          }} className="flex items-center gap-3 mb-8" data-id="element-67">
              <span className="w-12 h-[1px] bg-gray-900" data-id="element-68"></span>
              <span className="text-sm font-semibold uppercase tracking-widest text-gray-900" data-id="element-69">
                Офіційно по всій Україні
              </span>
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.1,
            ease: 'easeOut'
          }} className="text-5xl md:text-6xl lg:text-7xl font-semibold tracking-tight text-gray-900 mb-6 leading-[1.1]" data-id="element-70">
              Оцінка майна <br data-id="element-71" />
              <span className="text-gray-400" data-id="element-72">з економією до 25%</span>
            </motion.h1>

            {/* Mobile Image - Visible only on small screens */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.15,
            ease: 'easeOut'
          }} className="relative h-[300px] sm:h-[400px] w-full rounded-3xl overflow-hidden mb-6 lg:hidden" data-id="element-73">
              <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80&w=800" alt="Сучасна нерухомість" className="absolute inset-0 w-full h-full object-cover" data-id="element-74" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" data-id="element-75" />
              <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur-md p-4 rounded-2xl shadow-xl max-w-[200px]" data-id="element-76">
                <p className="text-xs text-gray-500 mb-1" data-id="element-77">
                  Відправка документів
                </p>
                <p className="text-sm font-semibold text-gray-900" data-id="element-78">
                  Того ж дня Новою Поштою
                </p>
              </div>
            </motion.div>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2,
            ease: 'easeOut'
          }} className="text-lg md:text-xl text-gray-600 mb-10 max-w-lg font-light leading-relaxed" data-id="element-79">
              Знижуємо оціночну вартість відносно е-Довідки в рамках чинного
              законодавства. Офіційний звіт з реєстрацією у базі ФДМУ.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.3,
            ease: 'easeOut'
          }} className="flex flex-col sm:flex-row gap-4 mb-16" data-id="element-80">
              <a href="#services" className="inline-flex items-center justify-center px-8 py-4 text-base font-medium text-white bg-gray-900 rounded-full hover:bg-gray-800 transition-all duration-300" data-id="element-81">
                Переглянути послуги
              </a>
              <a href="tel:+380971264678" className="inline-flex items-center justify-center px-8 py-4 text-base font-medium text-gray-900 bg-gray-50 rounded-full hover:bg-gray-100 transition-all duration-300" data-id="element-82">
                Зателефонувати
              </a>
            </motion.div>

            {/* Trust Indicators */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.4,
            ease: 'easeOut'
          }} className="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-8 border-t border-gray-100" data-id="element-83">
              <div data-id="element-84">
                <Clock className="text-gray-900 mb-3" size={24} strokeWidth={1.5} data-id="element-85" />
                <p className="font-medium text-gray-900 text-sm mb-1" data-id="element-86">
                  1 година
                </p>
                <p className="text-xs text-gray-500" data-id="element-87">
                  на отримання ідентифікатора
                </p>
              </div>
              <div data-id="element-88">
                <FileText className="text-gray-900 mb-3" size={24} strokeWidth={1.5} data-id="element-89" />
                <p className="font-medium text-gray-900 text-sm mb-1" data-id="element-90">
                  База ФДМУ
                </p>
                <p className="text-xs text-gray-500" data-id="element-91">
                  обов'язкове внесення звіту
                </p>
              </div>
              <div data-id="element-92">
                <ShieldCheck className="text-gray-900 mb-3" size={24} strokeWidth={1.5} data-id="element-93" />
                <p className="font-medium text-gray-900 text-sm mb-1" data-id="element-94">
                  100% Законно
                </p>
                <p className="text-xs text-gray-500" data-id="element-95">повне дотримання норм</p>
              </div>
            </motion.div>
          </div>

          {/* Right Column - Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative h-[600px] hidden lg:block rounded-[2.5rem] overflow-hidden bg-gray-100" data-id="element-96">
            <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80&w=1200" alt="Сучасна нерухомість" className="absolute inset-0 w-full h-full object-cover" data-id="element-97" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" data-id="element-98" />

            {/* Floating Badge */}
            <div className="absolute bottom-8 left-8 bg-white/90 backdrop-blur-md p-6 rounded-3xl shadow-xl max-w-xs" data-id="element-99">
              <p className="text-sm text-gray-500 mb-1" data-id="element-100">Відправка документів</p>
              <p className="text-lg font-semibold text-gray-900" data-id="element-101">
                Того ж дня Новою Поштою
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}